import gql from 'graphql-tag';

export const GET_SETTINGS = gql`
    query getSettings($key: String!) {
        settings: settings_by_pk(key:$key) {
            key
            value
        }
    }
`;

export const SAVE_SETTINGS = gql`
    mutation updateSettings($key: String!, $value: jsonb!) {
        update_settings_by_pk(pk_columns: {key: $key}, _set: {value: $value}) {
            key
            value
        }
    }
`;